import { Configuration, UsersApi } from '@/api';
import CustomToast from '@/components/CustomToast';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import useUserQuery from '@/modules/settings/hooks/useUserQuery';
import UserProfileForm, { FormData } from '@/modules/supplier/components/UserProfileForm';
import { UserIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

const Profile = () => {
  const { user, isLoading: isLoadingUser, invalidateQuery: invalidateQueryUser } = useUserQuery();

  const usersApi = new UsersApi(new Configuration(useAuth));

  const handleSubmitUserProfile = async (data: FormData) => {
    try {
      await usersApi.updateUser(data.id, data);

      toast.custom((t) => (
        <CustomToast id={t.id} message="Profile updated successfully!" visible={t.visible} />
      ));

      await invalidateQueryUser();
    } catch (error) {
      console.error('Error while updating user:', error);
    }
  };

  if (isLoadingUser) {
    return (
      <div className="flex justify-center py-20">
        <SpinnerIcon />
      </div>
    );
  }

  if (!user) {
    return;
  }

  return (
    <>
      <SettingsHeader title="Profile" icon={<UserIcon className="w-6 h-6" />} />

      <UserProfileForm user={user} onSubmit={handleSubmitUserProfile} />
    </>
  );
};

export default Profile;
